import { Http } from "../Http";
import { BookingButtonViewModel } from "../BookingButton/BookingButtonViewModel.csharp";

export class BookingSearchApi {
  public search = (query: string) => {
    return Http.get(
      `/api/booking-search?query=${encodeURIComponent(query)}`
    ) as Promise<BookingButtonViewModel[]>;
  };
}
